<div
  class="h-full card-classes rounded-2xl p-2 [@media(max-height:620px)]:p-1.5 md:p-2.5 2xl:p-3 hover:-translate-y-1 transition-shadow duration-300 cursor-pointer overflow-hidden"
  [ngClass]="['col-span-' + colSpan]" (click)="onClick()">

  <div [ngClass]="[displayClass, customClass === 'icon-left'
      ? 'flex-row items-start text-left'
      : 'flex-col items-center text-center', 'gap-2 [@media(max-height:620px)]:gap-1.5 md:gap-2.5 2xl:gap-3 w-full h-full']">

    <div class="p-1.5 [@media(max-height:620px)]:p-1 md:p-2 rounded-xl shrink-0"
      [ngClass]="[$safeNavigationMigration(data?.bgClass), iconClassType]">
    <app-icon [name]="$safeNavigationMigration(data?.icon)" [size]="18" [class]="'h-5 w-5 ' + data?.iconClass"></app-icon>
    </div>

    <div class="flex flex-col gap-0.5 md:gap-1 justify-between h-full flex-1">

      <h4 class="text-[13px] font-medium text-[#38385B] dark:text-ink-soft">
        {{ data?.label }}
      </h4>

      <p
        [ngClass]="[displayClass, 'flex-wrap items-center gap-1 md:gap-2 text-lg md:text-xl 2xl:text-2xl font-medium text-[#141437] dark:text-white leading-tight']">
        {{ data?.value }}

        @if(showComparisonValue){
          <span class="text-sm flex items-center gap-2 font-medium" [ngClass]="{
                  ' text-[#15B268] dark:text-[#15B268]': data.difference >= 0,
                  ' text-[#F05050] dark:text-[#F05050]': data.difference < 0
                }">
            <app-icon [name]=" data.difference >= 0 ? 'trendingUp' : 'trendingDown'" [size]="14"></app-icon> {{
            data?.difference }} @if(showPercentIcon){
            %
            }
          </span>
        }
      </p>
    </div>
  </div>
</div>